export default __webpack_public_path__ + "static/media/red_wine.3879d193.jpg";